/* eslint-disable camelcase */
import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";

import {
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  Locationwrapper,
} from "../../CreateEvent/style";

import { FormHeading } from "../../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { Main } from "../../AdminTeamCreation/styles";
import { Layout } from "../../EditWellnessJourney/styles";
import { Border } from "../../Journeys/styles";
import { ManagerIconContainer } from "../../Manager/styles";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { CommonButtonBorder } from "../../common/commonStyles";

import { fetchApi, getInitials } from "../../../utils/methods";
import { AllocateSpotPointsToUsers, GetSearchPeopleAdmin, GetUsersToShoutout } from "../../../redux/constants/apiConstants";
import { BrandingEmoji, FeedCloseIcon, RecognitionCloseIcon, RecognitionTickIcon } from "../../../utils/icons";

import StepsHeading from "../../../components/RecogntionAdmin/corevalues/stepNames";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useEffect } from "react";
import { getCompanyDepartment, getCompanyLocation } from "../../../redux/actions";
import SocialFeedsEmojiPicker from "../../SocialFeedsEmojiPicker";
import { CustomInputTextArea, DropDownStyledImage, ListDropdown, ProfilePicture, RectBox, TagUserCard, UserContainer, UserDropdownContainer, UserInitialsMain } from "../../SocialFeedsV2/styles";
import Image from "../../Image";
import { ImageUrl } from "../../../utils/constants";
import { showSuccessToast } from "../../UserDashboard/ToastHelper";

const awardOptions = [
  { id: "users", title: "Users", desc: "Select one or more employees" , label:"Users" },
  { id: "departments", title: "Departments", desc: "Award by department", label:"Department" },
  { id: "locations", title: "Locations", desc: "Award by location", label:"Location"},
  { id: "champions", title: "Wellness Champions", desc: "Award champion group(s)" , label:"Wellness Champion" }
];

const Heading = styled.div`
  margin-bottom: 20px;

color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 20px;
`;

const AwardBoxContainer = styled.div`
  display: flex;
  gap: 12px;
  margin: 16px 0;
  width:87%;
`;


const AwardBox = styled.div`
  padding: 12px;
  border-radius: 12px;
  border: 0.75px solid
    ${(props) =>
    props.active ? "var(--Crimson-Blush-300, #EEB3B4)" : "var(--Bg-Color-for-Light-theme-300, #DCDCDC)"};
  background: ${(props) =>
    props.active ? "var(--Crimson-Blush-500, #DA6C74)" : "var(--Bg-Color-for-Light-theme-600, #FEFEFE)"};
    color: ${(props) => (props.active ? "#fff" : "#184A61")};
  cursor: pointer;
  ${'' /* width: 139px; */}
  display:flex;
  flex-direction:column;
  justify-content:space-between;

  .title{
    ${'' /* color:  #184A61; */}
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 20px;

  }
  .desc{
    ${'' /* color: #184A61; */}
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
margin-top:12px;

  }
`;

// const Locationwrapper = styled.div`
//   padding: 12px;
//   border-radius: 8px;
// `;

const RecipientsCount = styled.div`
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  margin-top: 12px;
`;

export const DescriptionContainer = styled.div`
border-radius: 4px;
border: 1px solid #DCDCDC;
background: #FEFEFE;
padding:8px 16px;

.emoji-container{
  display:flex;
  justify-content:space-between;
}

.emojiIcon{
  ${'' /* display:flex; */}
  ${'' /* margin:auto auto auto 6px; */}
  cursor:pointer;
}
.char-count{
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #BDBDBD;
  display:flex;
  padding: 8px 0;
}
`

const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 28px;
  margin-bottom:12px;

  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 30px; 
`;

const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  background: #1f4b5c;
  border-radius: 50%;
  margin-right: 10px;
`;

const Label = styled.span`
  font-weight: 600;
  margin-right: 6px;
`;

const CreateSpotPointForm = ({ t, history, location,locationDetails,departmentDetails, getCompanyLocation, getCompanyDepartment,companyInfo }) => {
  // const [awardType, setAwardType] = useState("users");
  const [awardType, setAwardType] = useState(awardOptions[0]);
  const [description, setDescription] = useState("");
  const [spotPoints, setSpotPoints] = useState(null);
  const [step, setStep] = useState(1);
  const [isDisabled, setIsDisabled] = useState(false);
  const [recipientsCount, setRecipientsCount] = useState(0);
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [selectedUsersData, setSelectedUsersData] = useState([]);
  const [showSuggestor, setShowSuggestor] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [text, setText] = useState("");
  const [currentSelection, setCurrentSelection] = useState(null);
  const textarea = useRef(null);
  const wrapperRef = useRef(null);
  const onScroll = () => {};




  useEffect(() => {
    // reset everything when award type changes
    setSelectedUsersData([]);
    setDepartments([]);
    setLocations([]);
    setRecipientsCount(0);
    setText("");
    setEmployeeData([]);
    setShowSuggestor(false);
  }, [awardType]);



  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowSuggestor(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleKeyDown = (e) => {
    if (!showSuggestor) return;
  
    if (e.key === "ArrowDown") {
      setCurrentSelection((prev) =>
        prev < employeeData.length - 1 ? prev + 1 : 0
      );
    }
  
    if (e.key === "ArrowUp") {
      setCurrentSelection((prev) =>
        prev > 0 ? prev - 1 : employeeData.length - 1
      );
    }
  
    if (e.key === "Enter") {
      e.preventDefault();
      const user = employeeData[currentSelection];
      if (user) handleClick(user, currentSelection);
    }
  };

  const handleMouseHover = (index) => {
    setCurrentSelection(index);
  };

  const handleKey = (e) => {
    if (e.key === "Backspace" && text === "" && selectedUsersData.length > 0) {
      // Remove last user
      setSelectedUsersData(selectedUsersData.slice(0, -1));
    }
  };
  

  const fetchUsers = async (searchText) => {
    if (!companyInfo?.id) return;
    try {
      const res = await fetchApi(GetUsersToShoutout, "POST", {
        company_id: companyInfo.id,
        name: searchText,
        limit: 10,
        user_type: "all"
      });
  
      if (res.status === "success") {
        setEmployeeData(res.data.response || []);
      } else {
        setEmployeeData([]);
      }
    } catch (err) {
      window.console.error(err);
      setEmployeeData([]);
    }
  };

  const fetchChampions = async (searchText) => {
    if (!companyInfo?.id) return;
    try {
      const res = await fetchApi(GetSearchPeopleAdmin, "POST", {
        company_id: companyInfo.id,
        name: searchText,
        limit: 10,
        role: "CHAMPION",
        user_type: "all"
      });
  
      if (res.status === "success") {
        setEmployeeData(res.data.response || []);
      } else {
        setEmployeeData([]);
      }
    } catch (err) {
      window.console.error(err);
      setEmployeeData([]);
    }
  };

  const containsDefaultPng = (path) => path === "profile-Image/default.png";

  const removeSingleUserHandler = (user) => {
    setSelectedUsersData(selectedUsersData.filter((u) => u.uid !== user.uid));
  };

 




  const handlePeerInput = (e) => {
    const value = e.target.value;
    setText(value);
  
    if (value.length > 0) {
      setShowSuggestor(true);
      setCurrentSelection(0); 
    } else {
      setShowSuggestor(false);
    }
  };




  const handleClick = (user) => {
    if (!user?.uid) return; // safety
  
    setSelectedUsersData((prev) => {
      const exists = prev.find((u) => u.uid === user.uid);
      if (exists) return prev;
  
      return [...prev, user];
    });
  
    setText("");
    setShowSuggestor(false);
  
    // small delay ensures UI updates before focus
    window.setTimeout(() => {
      textarea.current?.focus();
    }, 0);
  };


  useEffect(() => {
    if (!text) return;
  
    const delay = window.setTimeout(() => {
      if (awardType?.id === "users") {
        fetchUsers(text);
      } else if (awardType?.id === "champions") {
        fetchChampions(text);
      }
    }, 300);
  
    return () => window.clearTimeout(delay);
  }, [text, awardType]);


  const redirect = () => {
    const fromAdmin = location?.state?.route === "admin";

    if (fromAdmin) {
      history.push("/company/wellness", {
        activeTab: "Library",
        activeLibraryTab: "Articles",
      });
    } else {
      history.goBack();
    }
  };

  useEffect(()=>{
    getCompanyLocation(companyInfo?.id);
    getCompanyDepartment(companyInfo?.id);
  },[])

  // const isStepValid = () => {
  //   // if (step === 1) return title.trim() !== "";
  //   if (step === 3) return description.trim() !== "";
  //   return true;
  // };


  const isStepValid = () => {
    if (step === 1) {
      return recipientsCount > 0;
    }
  
    if (step === 2) {
      return spotPoints > 0 && description.trim().length > 0;
    }
  
    if (step === 3) {
      return true;
    }
  
    return false;
  };

  const nextStep = () => {
    // if (!isStepValid()) {
    //   toast.error(t("Please fill all mandatory fields"));
    //   return;
    // }

    setStep((prev) => prev + 1);
    window.scrollTo(0, 0);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
    window.scrollTo(0, 0);
  };

  const SuccessToastMessage = (title, message) => {
    showSuccessToast(title, message, "383px");
  } 


  const getSuccessMessage = () => {
    const points = spotPoints;
    const count = recipientsCount;
  
    switch (awardType?.id) {
    case "departments":
      return count > 0
        ? `All ${count} ${count === 1 ? "Department" : "Departments"} received +${points} Spot Points`
        : "";

    case "locations":
      return count > 0
        ? `All ${count} ${count === 1 ? "Location" : "Locations"} received +${points} Spot Points`
        : "";

    case "champions":
      return `Wellness Champions selected received +${points} Spot Points`;

    case "users":
      return `Users selected received +${points} Spot Points`;

    default:
      return "";}
  };


  const onSubmit = (e) => {
    e.preventDefault();
    const userIds = selectedUsersData.map((u) => u.uid)
    const payload = {
      // title,
      company_id: companyInfo?.id,
      description: description,
      points_per_recipient: Number(spotPoints),
      department_ids : awardType.id === "departments" ? departments : [],
      location_ids:awardType.id === "locations" ? locations : [],
      team_ids: [],
      user_ids:awardType.id === "users" || awardType.id === "champions" ? userIds : []

    };

    createSpotPoint(payload);
  };
  

  const createSpotPoint = async (payload) => {
    setIsDisabled(true);
    try {
      const res = await fetchApi(AllocateSpotPointsToUsers, "POST", payload);
      if (res.status === "success") {
        SuccessToastMessage(
          "Spot Points Awarded!",
          getSuccessMessage()
        );
        // SuccessToastMessage("Spot points awarded successfully", res?.data?.message);
        // toast.success(res?.data?.[0] || "Spot points awarded successfully");
        history.push("/company/rewards-management/rewards");
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setIsDisabled(false);
    }
  };


  useEffect(() => {
    if (awardType?.id === "users" || awardType?.id === "champions") {
      setRecipientsCount(selectedUsersData.length);
    }
  }, [selectedUsersData, awardType]);



  // const handlePointsChange = (e) => {
  //   let value = e.target.value;
  //   if (value === "") {
  //     setSpotPoints("");
  //     return;
  //   }
  //   const num = Number(value);
  //   if (num <= 0) return;
  //   setSpotPoints(num);
  // };




  const handlePointsChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
  
    // allow empty
    if (!value) {
      setSpotPoints("");
      return;
    }
  
    // remove leading zeros
    value = value.replace(/^0+/, "");
  
    // limit to 5 digits
    value = value.slice(0, 5);
  
    setSpotPoints(value);
  };


  // const handlePointsChange = (e) => {
  //   let value = e.target.value;
  
  //   // allow empty (for backspace)
  //   if (value === "") {
  //     setSpotPoints("");
  //     return;
  //   }
  //   value = value.replace(/\D/g, "");

  //   if (value.length > 5) {
  //     value = value.slice(0, 5);
  //   }
  
  //   const num = Number(value);
  
  //   if (num <= 0) return;
  
  //   setSpotPoints(value); 
  // };


  

  const toggleDepartment = (id) => {
    let updated = [];

    if (departments.includes(id)) {
      updated = departments.filter((d) => d !== id);
    } else {
      updated = [...departments, id];
    }

    setDepartments(updated);
    setRecipientsCount(updated.length);
  };

  const toggleLocation = (id) => {
    let updated = [];

    if (locations.includes(id)) {
      updated = locations.filter((l) => l !== id);
    } else {
      updated = [...locations, id];
    }

    setLocations(updated);
    setRecipientsCount(updated.length);
  };

  const toggleAllDepartments = () => {
    if (departments.length === departmentDetails.length) {
      setDepartments([]);
      setRecipientsCount(0);
    } else {
      const allIds = departmentDetails.map((d) => d.id);
      setDepartments(allIds);
      setRecipientsCount(allIds.length);
    }
  };
  
  const toggleAllLocations = () => {
    if (locations.length === locationDetails.length) {
      setLocations([]);
      setRecipientsCount(0);
    } else {
      const allIds = locationDetails.map((l) => l.id);
      setLocations(allIds);
      setRecipientsCount(allIds.length);
    }
  };


  const getRecipientLabel = () => {
    if (awardType?.id === "users" || awardType?.id === "champions") {
      return recipientsCount === 1 ? "User" : recipientsCount > 1 ? "Users" : "";
    }
  
    if (awardType?.id === "locations" ) {
      return recipientsCount === 1 ? "location" : "locations";
    }
  
    if (awardType?.id === "departments") {
      return recipientsCount === 1 ? "department" : "departments";
    }
  
    return "";
  };

  const renderHeading = () => (
    <FormHeading color="#184A61">
      <div className="close-icon" onClick={redirect}>
        <ManagerIconContainer isWidth="32px">
          {RecognitionCloseIcon("#DA6C74")}
        </ManagerIconContainer>
      </div>
      {t("Award Spot Points")}
    </FormHeading>
  );

  const renderStepOne = () => (
    <div className="formBody">
      <AwardBoxContainer>
        {awardOptions.map((item) => (
          <AwardBox
            key={item.id}
            active={awardType.id === item.id}
            onClick={() => setAwardType(item)}
          >
            <div className="title" >{item.title}</div>
            <div className="desc">{item.desc}</div>
          </AwardBox>
        ))}
      </AwardBoxContainer>
      <Border style={{ background: "#EFEFEF", margin: "20px 0 0px 0" }} />

      {(awardType?.id === "users" || awardType?.id === "champions") &&<InputContainer>
        <StyledLabel isFont="16px" color="#184A61">
       
          { awardType.id === "champions" ? ("Which wellness champions would you like to give spot points? ") :("Who would you like to give spot points?")}
          {/* <span>*</span> */}
        </StyledLabel>

        <RectBox    ref={wrapperRef} isBorder={"1px solid #BDBDBD"} padding={selectedUsersData.length > 0} style={{position:"relative"}}>
          <CustomInputTextArea
            onKeyDown={handleKey}
            peer={1}
            isColor={"#184A61"}
            width={"100% !important"}
            border={"none"}
            widthTextArea={selectedUsersData.length > 0 ? "auto !important" : "100% !important"}
          >
            {selectedUsersData?.length > 0 &&
              selectedUsersData.map((data,index) => (
                <TagUserCard key={index}>
                  <div className="profile">
                    {!containsDefaultPng(data?.profile_image) ? (
                      <img src={`${ImageUrl}/${data?.profile_image}`} />
                    ) : (
                      <UserInitialsMain color={"#184A61"} isBg border size="12px">
                        {getInitials(data?.fullname || `${data.fname || ""} ${data.lname || ""}`)}
                      </UserInitialsMain>
                    )}
                  </div>
                  <div className="name">{data?.fullname || `${data.fname || ""} ${data.lname || ""}`}</div>
                  <div onClick={() => removeSingleUserHandler(data)}>{FeedCloseIcon()}</div>
                </TagUserCard>
              ))}

            <textarea
              placeholder={selectedUsersData?.length > 0 ? null : awardType.id === "champions" ? "Select Wellness Champions" : "Select users"}
              rows="4"
              onKeyDown={handleKeyDown}
              name="inspirationQuote"
              onChange={selectedUsersData?.length < 10 ? handlePeerInput : null}
              value={text}
              data-gramm_editor="false"
              className="CustomTextAreaField"
              onScroll={onScroll}
              spellCheck="false"
              ref={textarea}
              autoFocus
              style={{ caretColor: selectedUsersData?.length < 10 ? "" : "transparent", width: "100%" }}
            />
          </CustomInputTextArea>

          <UserContainer isHeight={"auto"} showSuggestor={showSuggestor}  
            width="350px"
            style={{
              position: "absolute",
              top: "100%",   
              left: 0,
              zIndex: 1000
            }}>
            {showSuggestor && text.length > 0 && (employeeData?.length > 0 ? (
              employeeData.map((user, index) => (
                <UserDropdownContainer
                  key={index}
                  index={index}
                  onMouseEnter={() => handleMouseHover(index)}
                  currentSelection={currentSelection}
                  // onMouseDown={() => handleClick(user, index)}
                  onMouseDown={(e) => {
                    e.preventDefault(); 
                    e.stopPropagation(); 
                    handleClick(user, index);
                  }}
                >
                  <ProfilePicture>
                    <DropDownStyledImage width="100%" left height="40px" style={{ padding: "5px" }}>
                      <div className="middle" style={{ display: "inline-block" }}>
                        {!containsDefaultPng(user.profile_image) ? (
                          <Image
                            style={{ width: "30px", display: "inline-block", border: "1px solid #BDBDBD" }}
                            image={user.profile_image}
                            alt={user.fname}
                          />
                        ) : (
                          <UserInitialsMain
                            border
                            isBg
                            color={"#184A61"}
                            style={{ width: "40px", height: "40px", margin: "5px 10px" }}
                          >
                            {getInitials(user.fullname || `${user.fname || ""} ${user.lname || ""}`)}
                          </UserInitialsMain>
                        )}
                      </div>
                      <ListDropdown index={index} currentSelection={currentSelection}>
                        <span style={{ marginLeft: "10px" }}>
                          {user.fullname || `${user.fname || ""} ${user.lname || ""}`.trim()}
                        </span>
                      </ListDropdown>
                    </DropDownStyledImage>
                  </ProfilePicture>
                </UserDropdownContainer>
              ))
            ) : (
              <span style={{color:"#184A61"}}>{ awardType?.id === "users" ? "No User Found" : "No Champions Found"}</span>
            ))}
          </UserContainer>
        </RectBox>
      </InputContainer>}

      {/* <Border style={{ background: "#EFEFEF", margin: "20px 0 0px 0" }} /> */}

      {/* Department Listing */}

      {awardType?.id === "departments" && (
        <Locationwrapper marginTop={'20px'}>
          <StyledLabel isFont="16px" color="#184A61" margin={"0px"}>
            {t("Select Department")}
            <span>*</span>
          </StyledLabel>
          {/* Select All */}
          <div className="checkBoxWidth">
            <span>
              <ManagerIconContainer
                selected={departments.length === departmentDetails.length}
              >
                <div className="archive-action" onClick={toggleAllDepartments}>
                  {departments.length === departmentDetails.length
                    ? RecognitionTickIcon("#DA6C74")
                    : null}
                </div>
              </ManagerIconContainer>
      
              Select All Departments
            </span>
          </div>

          {departmentDetails.map((dep) => (
            <div className="checkBoxWidth" key={dep.id}>
              <span>
                <ManagerIconContainer selected={departments.includes(dep.id)}>
                  <div
                    className="archive-action"
                    onClick={() => toggleDepartment(dep.id)}
                  >
                    {departments.includes(dep.id) ? RecognitionTickIcon("#DA6C74") : null}
                  </div>
                </ManagerIconContainer>

                {dep.department}
              </span>
            </div>
          ))}
        </Locationwrapper>
      )}

      {/* Location Listing */}

      {awardType?.id === "locations" && (
        <Locationwrapper>
          {/* Select All */}
          <div className="checkBoxWidth">
            <span>
              <ManagerIconContainer
                selected={locations.length === locationDetails.length}
              >
                <div className="archive-action" onClick={toggleAllLocations}>
                  {locations.length === locationDetails.length
                    ? RecognitionTickIcon("#DA6C74")
                    : null}
                </div>
              </ManagerIconContainer>
       
              Select All Locations
            </span>
          </div>

          {locationDetails.map((loc) => (
            <div className="checkBoxWidth" key={loc.id}>
              <span>
                <ManagerIconContainer selected={locations.includes(loc.id)}>
                  <div
                    className="archive-action"
                    onClick={() => toggleLocation(loc.id)}
                  >
                    {locations.includes(loc.id) ? RecognitionTickIcon("#DA6C74") : null}
                  </div>
                </ManagerIconContainer>

                {loc.location}
              </span>
            </div>
          ))}
        </Locationwrapper>
      )}


      <RecipientsCount>
       Recipients selected: {recipientsCount} {recipientsCount > 0 && ` ${getRecipientLabel()}`}
      </RecipientsCount>
    </div>
  );

  

  const onEmojiSelect = (emoji) => {
    const selectedEmoji = emoji?.native || emoji?.emoji || "";
  
    setDescription((prev) => {
      window.console.log("");
      return [...(prev + selectedEmoji)]
        .slice(0, 300)
        .join("");
    });
  
    setShowEmojiPicker(false);
  };


  const onChangeDescription=(e) => {
    const value = e.target.value;
  
    if ([...value].length <= 300) {
      setDescription(value);
    }
  }

  // const onChangeDescription = (e) => {
  //   const value = e.target.value;
  //   if (value.length <= 300) {
  //     setDescription(value);
  //   }
  // }

  const renderStepTwo = () => (
    <div className="formBody">

      <InputContainer>
        <StyledLabel isFont="16px" color="#184A61" margin={'0px'}>
          {t("Points per recipient")}
          <span>*</span>
        </StyledLabel>

        <StyledInputV2
          placeholder={t("Enter Points")}
          name="number"
          value={spotPoints}
          onChange={handlePointsChange}
          // onChange={(e) =>{setSpotPoints(e.target.value)}}
          maxLength="5"
          bgColor="white"
          style={{ background: "white" }}
          pColor="#BDBDBD"
          color="#184A61"
          border="1px solid #BDBDBD"
          type="text"
          inputMode="numeric"
        />
        <StyledLabel isFont="16px" color="#184A61" margin={'12px'} marginb={'0px'} style={{fontWeight:'700'}}>
          {t(`${awardType?.id === "locations" ? `Helper: Every user from ${awardType?.id === "locations" ? 'locations' : 'department'} selected will receive the same amount.` : 'Helper: Everyone selected will receive the same amount.' }`)}
        </StyledLabel>
      </InputContainer>

      <StyledLabel isFont="16px" color="#184A61" margin={'20px'} marginb={'12px'} style={{float:'unset'}}>
      Explain Why You’re Awarding Spot Points
      </StyledLabel>
      <DescriptionContainer>
        <StyledInputV2
          as="textarea"
          placeholder={t("Write Notification You Would Like To Say Users")}
          name="description"
          height="48px"
          // min="1"
          // step="1"
          value={description}
          onChange={onChangeDescription}
          // onChange={(e) =>{setDescription(e.target.value)}}
          maxLength="300"
          bgColor="white"
          style={{ background: "white" }}
          pColor="#BDBDBD"
          color="#184A61"
          border="unset"
          isPadding="0px"
        />

        <div className="emoji-container">
          <div className='emojiIcon' onClick={()=>setShowEmojiPicker(true)}>
            {BrandingEmoji("#DA6C74")}
          </div>
          <div className='char-count'>
            {description?.length}/300 | C
          </div>
        </div>

      </DescriptionContainer>

      {/* <Border style={{ background: "#EFEFEF", margin: "10px 0" }} /> */}

      {showEmojiPicker ? <SocialFeedsEmojiPicker selectEmoji={onEmojiSelect} 
      // emojiRef={this.inputRef} 
        hidePicker={()=>setShowEmojiPicker(false)}></SocialFeedsEmojiPicker> : null}
    </div>
  );

  const renderStepThree = () => (
    <div className="formBody">
      <StyledLabel isFont="18px" color="#184A61" margin={'0px'} style={{float:'unset',fontWeight:'700'}}>
        Notification:
      </StyledLabel>
      <StyledLabel isFont="18px" color="#184A61" margin={'12px'} style={{float:'unset'}}>
        {description}
        {/* Working together toward shared goals through collaboration and trust. */}
      </StyledLabel>
      <Border style={{ background: "#EFEFEF", margin: "20px 0" }} />
      <StyledLabel isFont="18px" color="#184A61" margin={'0px'} style={{float:'unset',fontWeight:'700'}}>
      Selection Summary:
      </StyledLabel>
      <SummaryRow>
        <SummaryItem>
          <Dot />
          <Label>Selection Type:</Label> {awardType?.label } ({recipientsCount})
        </SummaryItem>
    
        {/* <SummaryItem>
          <Dot />
          <Label>Recipients selected:</Label> {recipientsCount} {getRecipientLabel()}
        </SummaryItem> */}
    
        <SummaryItem>
          <Dot />
          <Label>Points Per User:</Label> {spotPoints} pts
        </SummaryItem>
      </SummaryRow>

      {/* <SummaryRow>
        <SummaryItem>
          <Dot />
          <Label>Estimated total:</Label> {spotPoints * recipientsCount}
        </SummaryItem>
      </SummaryRow> */}
    </div>
  );

  const isValid = isStepValid();

  return (
    <div style={{width:'1246px', margin:'20px auto'}}>
      <Layout>
        <div className="main">
          {renderHeading()}
          <Heading>
            {step === 1 ? <span>Step 1: Choose who you’d like to award points to.</span> : null}
            {step === 2 ? <span>Step 2: Award the points and write the description </span> : null}
            {step === 3 ? <span>Step 3:  Awarded Spot Points Summary</span> : null}
          </Heading>
  
          <Container height="100%"   isStepHeight={step === 3 ? "auto" : step === 1 ?  "auto" : step ===2 ? "auto" : ""} isMinHeight={step === 3 ? "100px" :  step === 1 ?  "272px" : step ===2 ? "300px" : "" } stepBackground="#005C87" color="#005C87" paddingForm>
  
            <div className="stepsNameHighlight">
              <StepsHeading
                stepCount={step}
                type="spot-points"
                padding="20px 20px 265px 20px"
              />
            </div>
  
            <div className="form" >
              <form onSubmit={onSubmit}>
                {step === 1 && renderStepOne()}
                {step === 2 && renderStepTwo()}
                {step === 3 && renderStepThree()}
              </form>
            </div>
  
          </Container>
  
          <ButtonContainer style={{ width: "100%", left: "0" }}>
            <Main>
              <div style={{ display: "flex", width: "100%", justifyContent: step > 1 ? 'space-between' :"flex-end" }}>
                {step > 1 && (
                  <CommonButtonBorder width="200px" height="48px" onClick={prevStep}>
                    {t("Back")}
                  </CommonButtonBorder>
                )}
  
                {step < 3 && (
                  <CommonButtonPopup
                    height="48px"
                    width="200px"
                    disabled={!isValid}
                    onClick={isValid ? nextStep : null}
                    style={{
                      backgroundColor: isValid ? "#DA6C74" : "#EFEFEF",
                      color: isValid ? "#FFFFFF" : "#666666",
                    }}
                  >
                    {t("Next")}
                  </CommonButtonPopup>
                )}
  
                {step === 3 && (
                  <CommonButtonPopup
                    height="48px"
                    width="200px"
                    disabled={isDisabled || !isValid}
                    onClick={(isValid || !isDisabled) ? onSubmit : null}
                    style={{
                      backgroundColor: !isValid ? "#EFEFEF" : "#DA6C74",
                      color: !isValid ? "#666666" : "#FFFFFF",
                    }}
                  >
                    Done
                  </CommonButtonPopup>
                )}
              </div>
            </Main>
          </ButtonContainer>
        </div>
      </Layout>
    </div>
  );
};

CreateSpotPointForm.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  locationDetails:PropTypes.array,
  departmentDetails:PropTypes.array,
  companyInfo:PropTypes.object,
  getCompanyLocation:PropTypes.func,
  getCompanyDepartment:PropTypes.func
};

const mapStateToProps = (state) => ({
  locationDetails: state.register.locationDetails,
  departmentDetails: state.register.departmentDetails
});

const mapDispatchToProps = (dispatch) => ({
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id))
});

export default withRouter(connect(mapStateToProps , mapDispatchToProps)(withTranslation()(CreateSpotPointForm)));